$(function () {
    $(document).on('click', '.attachment-add', function (e) {
        e.preventDefault();

        const controlForm = $('.mail-attachments:first'),
            currentEntry = $(this).parents('.attachment-entry:first'),
            newEntry = $(currentEntry.clone()).appendTo(controlForm);

        newEntry.find('input').val('');
        controlForm.find('.attachment-entry:not(:last) .attachment-add')
            .removeClass('attachment-add').addClass('attachment-remove')
            .removeClass('btn-success').addClass('btn-danger')
            .html('<span class="fa fa-trash"></span>');
    }).on('click', '.attachment-remove', function (e) {
        $(this).parents('.attachment-entry:first').remove();

        e.preventDefault();
        return false;
    });
});
